import type { FC } from "react"

export const ChevronRightIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.293 5.293C7.10553 5.48053 7.00021 5.73484 7.00021 6C7.00021 6.26516 7.10553 6.51947 7.293 6.707L10.586 10L7.293 13.293C7.10084 13.4816 6.99005 13.7342 6.99233 13.9964C6.9946 14.2586 7.09978 14.5094 7.28518 14.6948C7.47059 14.8802 7.7214 14.9854 7.9836 14.9877C8.2458 14.99 8.4984 14.8892 8.687 14.707L12.707 10.707C12.8945 10.5195 12.9998 10.2652 12.9998 10C12.9998 9.73484 12.8945 9.48053 12.707 9.293L8.707 5.293C8.51947 5.10553 8.26516 5.00021 8 5.00021C7.73484 5.00021 7.48053 5.10553 7.293 5.293Z"
        fill="currentColor"
      />
    </svg>
  )
}
